import { CreateMUIStyled, styled as styled5 } from '@mui/material'
import { BaseThemeType } from '../theme/BaseTheme'

export const styled: CreateMUIStyled<BaseThemeType> = styled5
